module.exports = "pegasus_template/assets/blocks/landing-page-element-button.png";